import React, { Component } from 'react';
import { Form, Button, Modal } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { getSnapshot, } from 'mobx-state-tree';

class CustomerForm extends Component {
  
  initialSnapshot = null

  constructor(props) {
    super(props)
    if (props.model) {
      this.initialSnapshot = getSnapshot(props.model)
    }
  }

  handleSave = () => {
    // if (!hasParent(this.props.model)) {
    //   this.props.store.setCollectionItemFromSnapshot('customers', getSnapshot(this.props.model))
    // }
    // this.props.model.save()
    this.props.onSave()
    this.props.onClose()
  }

  handleCancel = () => {
    // applySnapshot(this.props.model, this.initialSnapshot)
    this.props.onClose()
  }

  render() {
    if (!this.props.model) return null
    const customer = this.props.model
    const handleChangeName = event => customer.setName(event.target.value)
    const handleChangeCode = event => customer.setCode(event.target.value.substr(0, 4))
    const handleChangeContact = event => customer.setContact(event.target.value)
    const handleChangeEmail = event => customer.setEmail(event.target.value)
    const handleChangePhone = event => customer.setPhone(event.target.value)
    const handleChangeFax = event => customer.setFax(event.target.value)
    const handleChangePhysicalAddress = event => customer.setPhysicalAddress(event.target.value)
    const handleChangePostalAddress = event => customer.setPostalAddress(event.target.value)
    const handleChangeComment = event => customer.setComment(event.target.value)

    return (
      <Modal open={this.props.isOpen} size='tiny'>
        <Modal.Header content={customer.name || 'Unnamed Customer'} />
        <Modal.Content scrolling>
          <Form as='div'>
            <Form.Group>
              <Form.Input width={12} label='Customer name' value={customer.name} onChange={handleChangeName} autoFocus />
              <Form.Input width={4} maxLength={4} label='Short code' value={customer.code} onChange={handleChangeCode} />
            </Form.Group>
            <Form.Group>
              <Form.Input width={6} label='Contact person' value={customer.contact} onChange={handleChangeContact} />
              <Form.Input width={10} label='Email address' value={customer.email} onChange={handleChangeEmail} />
            </Form.Group>
            <Form.Group>
              <Form.Input width={6} label='Phone' value={customer.phone} onChange={handleChangePhone} />
              <Form.Input width={6} label='Fax' value={customer.fax} onChange={handleChangeFax} />
            </Form.Group>
            <Form.Group widths='equal'>
              <Form.TextArea label='Physical address' value={customer.physicalAddress} onChange={handleChangePhysicalAddress} />
              <Form.TextArea label='Postal address' value={customer.postalAddress} onChange={handleChangePostalAddress} />
            </Form.Group>
            <Form.Input label='Comment' value={customer.comment} onChange={handleChangeComment} />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button positive disabled={!customer.isValid} onClick={this.handleSave} content='Save' />
          <Button color='orange' onClick={this.handleCancel} content='Cancel' />
        </Modal.Actions>
      </Modal>
    )
  }
}

export default inject('store')(observer(CustomerForm));


// WEBPACK FOOTER //
// ./src/components/customers/CustomerForm.js